/* eslint-disable prettier/prettier */
export const listOrgProfileShepherds = /* GraphQL */ `
  query listOrgProfileShepherds(
    $orgId: ID!
    $limit: Int
    $filter: ModelProfileOrganizationV2FilterInput
    $nextToken: String
  ) {
    listProfilesByOrgV2(filter: $filter, limit: $limit, nextToken: $nextToken, orgID: $orgId) {
      items {
        profile {
          alias
          email
          id
          l2manager
          level
          manager
          name
          shepherds(limit: 1000) {
            items {
              shepherd {
                alias
                email
                id
                name
                title
              }
            }
          }
          status
          title
        }
      }
      nextToken
    }
  }
`;

export const listProfilesByShepherd = /* GraphQL */ `
  query listProfilesByShepherd($id: ID!, $limit: Int, $nextToken: String) {
    getProfile(id: $id) {
      cohortMembers(nextToken: $nextToken, limit: $limit) {
        items {
          profile {
            alias
            brStatus
            calibrations(limit: 1000) {
              items {
                calibrationId
                independentCount
                reverseShadowCount
                reviewCount
                shadowCount
                status
              }
            }
            email
            id
            l2manager
            learnUserId
            level
            manager
            name
            orgs(limit: 1000) {
              items {
                orgID
              }
            }
            preferredTimezoneId
            title
            status
            updatedAt
          }
        }
        nextToken
      }
    }
  }
`;

export const canManageShepherdProfile = /* GraphQL */ `
  query CanManageShepherdProfile($orgId: ID!, $profileId: ID!) {
    canManageShepherdProfile(orgId: $orgId, profileId: $profileId)
  }
`;

export const listShepherdProfileNotes = /* GraphQL */ `
  query ListShepherdProfileNotes($orgId: ID!, $profileId: ID!, $limit: Int, $nextToken: String) {
    listShepherdProfileNotes(orgId: $orgId, profileId: $profileId, limit: $limit, nextToken: $nextToken) {
      items {
        commentType
        content
        createdAt
        id
        interviewerID
        interviewer {
          id
          isBarRaiserInterviewer
          participantConfig {
            id
            name
          }
          interviewerRole
        }
        loopEventID
        loopEvent {
          date
          eventstarttime
          id
          orgID
        }
        phoneScreenID
        phoneScreen {
          date
          eventstarttime
          id
          orgID
        }
        profile {
          alias
          email
          id
          name
          title
        }
        rating
        restricted
        updatedAt
      }
      nextToken
    }
  }
`;

export const upsertShepherdProfileCalibration = /* GraphQL */ `
  mutation UpsertShepherdProfileCalibration($orgId: ID!, $input: ShepherdProfileCalibrationInput!) {
    upsertShepherdProfileCalibration(orgId: $orgId, input: $input)
  }
`;

export const createShepherdProfileNote = /* GraphQL */ `
  mutation CreateShepherdProfileNote($orgId: ID!, $input: CreateShepherdProfileNoteInput!) {
    createShepherdProfileNote(orgId: $orgId, input: $input)
  }
`;

export const removeShepherdProfileAssignment = /* GraphQL */ `
  mutation RemoveShepherdProfileAssignment($orgId: ID!, $profileId: ID!, $shepherdId: ID!) {
    removeShepherdProfileAssignment(orgId: $orgId, profileId: $profileId, shepherdId: $shepherdId)
  }
`;
